import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-harta',
  templateUrl: './harta.component.html',
  styleUrls: ['./harta.component.scss']
})
export class HartaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
